export function getOSData() {
    var os = undefined;
    var clientStrings = [
        { s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/ },
        { s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/ },
        { s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/ },
        { s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/ },
        { s: 'Windows Vista', r: /Windows NT 6.0/ },
        { s: 'Windows Server 2003', r: /Windows NT 5.2/ },
        { s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/ },
        { s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/ },
        { s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/ },
        { s: 'Windows 98', r: /(Windows 98|Win98)/ },
        { s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/ },
        { s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
        { s: 'Windows CE', r: /Windows CE/ },
        { s: 'Windows 3.11', r: /Win16/ },
        { s: 'Android', r: /Android/ },
        { s: 'Open BSD', r: /OpenBSD/ },
        { s: 'Sun OS', r: /SunOS/ },
        { s: 'Chrome OS', r: /CrOS/ },
        { s: 'Linux', r: /(Linux|X11(?!.*CrOS))/ },
        { s: 'iOS', r: /(iPhone|iPad|iPod)/ },
        { s: 'Mac OS X', r: /Mac OS X/ },
        { s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
        { s: 'QNX', r: /QNX/ },
        { s: 'UNIX', r: /UNIX/ },
        { s: 'BeOS', r: /BeOS/ },
        { s: 'OS/2', r: /OS\/2/ },
        { s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ }
    ];
    for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(navigator.userAgent)) {
            os = cs.s;
            break;
        }
    }

    var osVersion = undefined;

    if (/Windows/.test(os)) {
        osVersion = /Windows (.*)/.exec(os)[1];
        os = 'Windows';
    }

    switch (os) {
        case 'Mac OS X':
            // eslint-disable-next-line
            osVersion = /Mac OS X (10[\.\_\d]+)/.exec(navigator.userAgent)[1];
            break;

        case 'Android':
            // eslint-disable-next-line
            osVersion = /Android ([\.\_\d]+)/.exec(navigator.userAgent)[1];
            break;

        case 'iOS':
            // eslint-disable-next-line
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(navigator.appVersion);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
            
        default:
            break;
    }

    return {
        os: os,
        osVersion: osVersion,
    };
}

// https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
export function isiOS() {
    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    var isAppleDevice = navigator.userAgent.includes('Macintosh');
    var isTouchScreen = navigator.maxTouchPoints >= 1;   // true for iOS 13 (and hopefully beyond)

    return isIOS || (isAppleDevice && isTouchScreen);
}

export function isiOSOrMac() {
    return isiOS() || navigator.userAgent.includes("Mac") 
}

// https://stackoverflow.com/a/40932301/4564156 from https://stackoverflow.com/questions/17989777/detect-if-ios-is-using-webapp
// search 'standalone' on https://developer.mozilla.org/en-US/docs/Web/API/Navigator
export function isInWebAppiOS() {
    return window.navigator.standalone;
}

export function isInDemoMode() {
    return isInAdminDemoMode() || isInNonAdminDemoMode();
}
export function isInAdminDemoMode() {
    return window.location.href.endsWith("/admin-demo");
}
export function isInNonAdminDemoMode() {
    return window.location.href.endsWith("/demo");
}